<template>
  <div class="cyryDialog">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="从业人员基本信息"
      :visible="dialogFormVisible"
      center
      @close="closeDialog"
    >
      <div class="leftcyry">
        <div v-for="(item, i) in cardImg" :key="i" class="card_img_item">
          <el-upload
            :disabled="cyrytype"
            class="upload-demo"
            :action="returnSaveFile"
            :data="item.OCR"
            :show-file-list="false"
            :headers="token"
            :before-upload="beforeUpload"
          >
            <el-image
              v-loading="item.loading"
              v-preventReClick
              :src="item.img"
              :fit="item.name"
              @click="cardType = item.type"
            />
            <p>{{ item.name }}</p>
          </el-upload>
        </div>
      </div>
      <div class="rightcyry">
        <el-form ref="form" :model="form" :rules="rules" :inline="true">
          <el-form-item label="姓名:" prop="xm">
            <el-input
              v-model="form.xm"
              :disabled="cyrytype"
              placeholder="请输入姓名"
            />
          </el-form-item>
          <el-form-item label="性别:" prop="xb">
            <el-select
              v-model="form.xb"
              placeholder="请选择性别"
              :disabled="cyrytype"
            >
              <el-option
                v-for="item in sys_user_sex"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="民族:">
            <el-select
              v-model="form.mz"
              placeholder="请选择民族"
              :disabled="cyrytype"
            >
              <el-option
                v-for="item in yzd_mz"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="证件类型:" prop="zjlx">
            <el-select
              v-model="form.zjlx"
              placeholder="请选择"
              :disabled="cyrytype"
            >
              <el-option
                v-for="item in yzd_zjlx"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="!zjlxtype" label="证件名称:" prop="qtzj">
            <el-select
              v-model="form.qtzj"
              placeholder="请选择"
              :disabled="cyrytype"
            >
              <el-option
                v-for="item in yzd_ry_zjmc"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="证件号码:"
            prop="zjhm"
            :class="{ elForm: zjlxtype }"
          >
            <el-input
              v-model="form.zjhm"
              :disabled="cyrytype"
              placeholder="请输入证件号码"
            />
          </el-form-item>
          <el-form-item v-if="!zjlxtype" label="有效期:" required class="yxq">
            <el-col :span="11.5">
              <el-form-item prop="yxqxKs">
                <el-date-picker
                  v-model="form.yxqxKs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="1"
              style="margin: 0 20px; text-align: center; width: 14px"
            >
              <span>至</span>
            </el-col>
            <el-col :span="11.5">
              <el-form-item prop="yxqxJs">
                <el-date-picker
                  v-model="form.yxqxJs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions1"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item v-if="!zjlxtype" label="发证机关:" prop="fzjg">
            <el-input
              v-model="form.fzjg"
              placeholder="请输入发证机关"
              :disabled="cyrytype"
            />
          </el-form-item>
          <el-form-item label="岗位:" prop="gw">
            <el-select
              v-model="zwList"
              multiple
              placeholder="请选择岗位"
              :disabled="cyrytype"
            >
              <el-option
                v-for="item in yzd_cyry_zw"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="聘用时间:" prop="pysj">
            <el-date-picker
              v-model="form.pysj"
              :disabled="cyrytype"
              type="date"
              placeholder="请选择时间"
              style="width: 174px"
            />
          </el-form-item>

          <el-form-item v-if="zwtype" label="驾驶证号:" prop="jszZjhm">
            <el-input
              v-model="form.jszZjhm"
              :disabled="cyrytype"
              placeholder="请输入驾驶证号"
            />
          </el-form-item>
          <el-form-item v-if="zwtype" label="准驾车型:" prop="jszZjcx">
            <el-input
              v-model="form.jszZjcx"
              :disabled="cyrytype"
              placeholder="请输入准驾车型"
            />
          </el-form-item>
          <el-form-item v-if="zwtype" label="有效期:" required class="yxq">
            <el-col :span="11.5">
              <el-form-item prop="jszYxqKs">
                <el-date-picker
                  v-model="form.jszYxqKs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="1"
              style="margin: 0 20px; text-align: center; width: 14px"
            >
              <span>至</span>
            </el-col>
            <el-col :span="11.5">
              <el-form-item prop="jszYxqJs">
                <el-date-picker
                  v-model="form.jszYxqJs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions1"
                />
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item v-if="zwtype" label="发证机关:" prop="jszFzjg">
            <el-input
              v-model="form.jszFzjg"
              placeholder="请输入发证机关"
              :disabled="cyrytype"
            />
          </el-form-item>

          <el-form-item v-if="zwtype1" label="押运证号:" prop="yyzZjhm">
            <el-input
              v-model="form.yyzZjhm"
              placeholder="请输入押运证号"
              :disabled="cyrytype"
            />
          </el-form-item>
          <el-form-item v-if="zwtype1" label="有效期:" required class="yxq">
            <el-col :span="11.5">
              <el-form-item prop="yyzYxqKs">
                <el-date-picker
                  v-model="form.yyzYxqKs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="line"
              :span="1"
              style="margin: 0 20px; text-align: center; width: 14px"
            >
              <span>至</span>
            </el-col>
            <el-col :span="11.5">
              <el-form-item prop="yyzYxqJs">
                <el-date-picker
                  v-model="form.yyzYxqJs"
                  :disabled="cyrytype"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions1"
                />
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item v-if="zwtype1" label="发证机关:" prop="yyzFzjg">
            <el-input
              v-model="form.yyzFzjg"
              placeholder="请输入发证机关"
              :disabled="cyrytype"
            />
          </el-form-item>

          <el-form-item label="手机号码:" prop="sjhm">
            <el-input
              v-model="form.sjhm"
              :disabled="cyrytype || cyrylxsjhdisabled"
              placeholder="请输入手机号码"
            />
          </el-form-item>

          <el-form-item label="办公电话:">
            <el-input
              v-model="form.bgdh"
              :disabled="cyrytype"
              placeholder="请输入办公电话"
            />
          </el-form-item>
          <el-form-item label="籍贯:">
            <el-input v-if="cyrytype"
                      v-model="form.jgLabel == null?'':form.jgLabel.replaceAll(',',' / ')" disabled
            />
            <el-cascader v-else
              v-model="jgList"
              clearable
              placeholder="请选择籍贯"
              :props="props"
              filterable
            />
          </el-form-item>

          <el-form-item label="实际住址:" prop="sjzz">
            <el-input
              v-model="form.sjzz"
              :disabled="cyrytype"
              placeholder="请输入实际住址"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; margin-left: 50px"
          @click="closeDialog()"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  url1,
  returnSaveFile,
  returnShowPic,
  getToken,
  getkv,
} from '@/assets/js/common.js'
import { getXzqTree, getXzqTreeS } from '@/assets/js/step2.js'
export default {
  name: 'CyryDialog',
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: {}
    },
    cyrytype: {
      type: Boolean,
      default: {}
    }
  },
  data() {
    const telphoneValidate = (rule, value, callback) => {
      if (!this.form.sjhm) {
        callback(new Error('手机号不能为空!'))
      } else if (value) {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      pickerOptions: {
        disabledDate: (time) => {
          return time > Date.now()
        }
      },
      pickerOptions1: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '永久日期',
            onClick(picker) {
              const date = new Date('2099-12-31')
              picker.$emit('pick', date)
            }
          }
        ]
      },
      props: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: level >= 1
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: level >= 3
                }))
                resolve(nodes)
              })
            }
          }, 200)
        }
      },
      token: {
        Authorization: getToken()
      },
      cardType: 0, // 图片为正面，反面或其他
      returnSaveFile: '', // 保存图片
      returnShowPic: '', // 回显图片
      URL1: '',
      cardImglist: [
        {
          name: '证件人像面（500KB以内）',
          type: 1,
          img: require('@/assets/img/zjrlx.png'),
          imgbf: require('@/assets/img/zjrlx.png'),
          closeBox: false,
          formname: 'zjzpZm',
          // loading: true,
          OCR: {
            sbzjlx: 'sfzZm'
          }
        },
        {
          name: '证件国徽面（500KB以内）',
          type: 2,
          img: require('@/assets/img/zjghx.png'),
          imgbf: require('@/assets/img/zjghx.png'),
          closeBox: false,
          formname: 'zjzpFm',
          // loading: true,
          OCR: {
            sbzjlx: 'sfzFm'
          }
        },
        {
          name: '上传驾驶证附件',
          type: 3,
          img: require('@/assets/img/zjrlx.png'),
          imgbf: require('@/assets/img/zjrlx.png'),
          closeBox: false,
          formname: 'jszZjurl'
          // loading: true,
        },
        {
          name: '上传押运证附件',
          type: 4,
          img: require('@/assets/img/zjrlx.png'),
          imgbf: require('@/assets/img/zjrlx.png'),
          closeBox: false,
          formname: 'yyzZjurl'
          // loading: true,
        }
      ],
      fileList: [],
      form: {
        xm: '', // 姓名
        xb: '', // 性别
        zjhm: '', // 证件号码
        zjlx: '', // 证件类型
        qtzj: '', // 证件名称
        yxqxKs: '',
        yxqxJs: '',
        fzjg: '',
        mz: '', // 民族
        gw: '', // 岗位
        pysj: '', // 聘用时间
        sjhm: '', // 手机号码
        bgdh: '', // 办公电话
        jg: '', // 籍贯
        jgLabel: '', // 籍贯
        sjzz: '', // 实际住址
        zjzpZm: '',
        zjzpFm: '',
        jszZjurl: '',
        yyzZjurl: '',
        jszZjhm: '', // 驾驶证号
        jszZjcx: '', // 准驾车型
        jszYxqKs: '', // 有效期
        jszYxqJs: '', // 有效期
        jszFzjg: '', // 发证机关
        yyzZjhm: '',
        yyzYxqKs: '',
        yyzYxqJs: '',
        yyzFzjg: ''
      },
      rules: {
        xm: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        xb: [{ required: true, message: '请选择性别', trigger: 'blur' }],
        zjhm: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
        zjlx: [{ required: true, message: '请选择', trigger: 'blur' }],
        qtzj: [{ required: true, message: '请选择', trigger: 'blur' }],
        fzjg: [{ required: true, message: '请输入', trigger: 'blur' }],
        yxqxKs: [{ required: true, message: '请选择', trigger: 'blur' }],
        yxqxJs: [{ required: true, message: '请选择', trigger: 'blur' }],
        gw: [{ required: true, message: '请选择岗位', trigger: 'blur' }],
        pysj: [{ required: true, message: '请输入聘用时间', trigger: 'blur' }],
        jszZjhm: [
          { required: true, message: '请输入驾驶证号', trigger: 'blur' }
        ],
        jszZjcx: [
          { required: true, message: '请输入准驾车型', trigger: 'blur' }
        ],
        jszYxqKs: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur'
          }
        ],
        jszYxqJs: [{ required: true, message: '请选择时间', trigger: 'blur' }],
        jszFzjg: [
          { required: true, message: '请输入发证机关', trigger: 'blur' }
        ],
        yyzZjhm: [{ required: true, message: '请输入', trigger: 'blur' }],
        yyzYxqKs: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur'
          }
        ],
        yyzYxqJs: [{ required: true, message: '请选择时间', trigger: 'blur' }],
        yyzFzjg: [
          { required: true, message: '请输入发证机关', trigger: 'blur' }
        ],
        sjhm: [
          {
            required: true,
            validator: telphoneValidate,
            trigger: 'blur',
            min: 11,
            max: 11
          }
        ],
        sjzz: [{ required: true, message: '请输入实际住址', trigger: 'blur' }]
      },
      yzd_zjlx: [], // 证件类型
      yzd_ry_zjmc: [], // 其他证件
      yzd_mz: [], // 民族
      yzd_cyry_zw: [], // 岗位
      sys_user_sex: [], // 性别
      id: '',
      cyrylxsjh: '',
      zwList: [],
      jgList: []
    }
  },
  computed: {
    cyrylxsjhdisabled() {
      if (this.cyrylxsjh == '01' || this.cyrylxsjh == '04') return true
      else return false
    },
    zwtype() {
      if (this.form.gw.includes('2')) return true
      else return false
    },
    zwtype1() {
      if (this.form.gw.includes('1')) return true
      else return false
    },
    zjlxtype() {
      if (this.form.zjlx == '1' || this.form.zjlx == '') return true
      else return false
    },
    cardImg: {
      // zjlxtype证件类型 身份证true zwtype驾驶员  zwtype1押运员
      get() {
        if (this.zwtype && this.zwtype1 && this.zjlxtype) {
          return this.cardImglist
        } else if (this.zwtype && this.zwtype1 && !this.zjlxtype) {
          return [
            ...this.cardImglist.slice(0, 1),
            ...this.cardImglist.slice(2)
          ]
        } else if (this.zwtype && !this.zwtype1 && this.zjlxtype) {
          return this.cardImglist.slice(0, 3)
        } else if (this.zwtype && !this.zwtype1 && !this.zjlxtype) {
          return [
            ...this.cardImglist.slice(0, 1),
            ...this.cardImglist.slice(2, 3)
          ]
        } else if (!this.zwtype && this.zwtype1 && this.zjlxtype) {
          return [
            ...this.cardImglist.slice(0, 2),
            ...this.cardImglist.slice(3)
          ]
        } else if (!this.zwtype && this.zwtype1 && !this.zjlxtype) {
          return [
            ...this.cardImglist.slice(0, 1),
            ...this.cardImglist.slice(3)
          ]
        } else if (!this.zwtype && !this.zwtype1 && this.zjlxtype) {
          return this.cardImglist.slice(0, 2)
        } else if (!this.zwtype && !this.zwtype1 && !this.zjlxtype) {
          return this.cardImglist.slice(0, 1)
        }
      },
      set(val) {
        return val
      }
    }
  },
  watch: {
    'form.jg': {
      deep: true,
      handler(val, oldVal) {
        if (this.form.jg) {
          this.jgList = this.form.jg.split(',').map(Number)
        }
      }
    }
  },
  created() {
    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    getkv('yzd_zjlx').then((e) => {
      this.yzd_zjlx = e.data.data
    })
    getkv('yzd_ry_zjmc').then((e) => {
      this.yzd_ry_zjmc = e.data.data
    })
    getkv('yzd_mz').then((e) => {
      this.yzd_mz = e.data.data
    })
    getkv('yzd_cyry_gw').then((e) => {
      this.yzd_cyry_zw = e.data.data
    })

    this.sys_user_sex = [
      {
        value: '0',
        label: '男'
      },
      {
        value: '1',
        label: '女'
      },
      {
        value: '2',
        label: '未知'
      }
    ]
  },
  mounted() {
    this.$nextTick(() => {})
  },
  methods: {
    // 上传之前
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    // 初始化表单内容
    getformMes(dataMes) {
      this.id = dataMes.id
      this.cyrylxsjh = dataMes.cyrylx
      this.$nextTick(() => {
        this.form = Object.assign(
          {},
          {
            xm: dataMes.xm, // 姓名
            xb: dataMes.xb, // 性别
            zjhm: dataMes.zjhm, // 证件号码
            zjlx: dataMes.zjlx, // 证件类型
            qtzj: dataMes.qtzj, // 证件名称
            yxqxKs: dataMes.yxqxKs,
            yxqxJs: dataMes.yxqxJs,
            fzjg: dataMes.fzjg,
            mz: dataMes.mz, // 民族
            gw: dataMes.gw, // 岗位
            pysj: dataMes.pysj, // 聘用时间
            jszZjhm: dataMes.jszZjhm, // 驾驶证号
            jszZjcx: dataMes.jszZjcx, // 准驾车型
            jszYxqKs: dataMes.jszYxqKs, // 有效期
            jszYxqJs: dataMes.jszYxqJs, // 有效期
            jszFzjg: dataMes.jszFzjg, // 发证机关
            yyzZjhm: dataMes.yyzZjhm,
            yyzYxqKs: dataMes.yyzYxqKs,
            yyzYxqJs: dataMes.yyzYxqJs,
            yyzFzjg: dataMes.yyzFzjg,
            sjhm: dataMes.sjhm, // 手机号码
            bgdh: dataMes.bgdh, // 办公电话
            jg: dataMes.jg, // 籍贯
            jgLabel: dataMes.jgLabel, // 籍贯
            sjzz: dataMes.sjzz, // 实际住址
            zjzpZm: dataMes.zjzpZm,
            zjzpFm: dataMes.zjzpFm,
            jszZjurl: dataMes.jszZjurl,
            yyzZjurl: dataMes.yyzZjurl
          }
        )
        this.zwList = dataMes.gw.split(',')
        // setTimeout(() => {
        this.jgList = dataMes.jg.split(',').map(Number)
        // }, 1000);
        this.cardImg.forEach((item) => {
          if (item.type == 1 && dataMes.zjzpZm != '' && dataMes.zjzpZm != null) { item.img = this.returnShowPic + dataMes.zjzpZm } else if (
            item.type == 2 &&
            dataMes.zjzpFm != '' &&
            dataMes.zjzpFm != null
          ) { item.img = this.returnShowPic + dataMes.zjzpFm } else if (
            item.type == 3 &&
            dataMes.jszZjurl != '' &&
            dataMes.jszZjurl != null
          ) { item.img = this.returnShowPic + dataMes.jszZjurl } else if (
            item.type == 4 &&
            dataMes.yyzZjurl != '' &&
            dataMes.yyzZjurl != null
          ) { item.img = this.returnShowPic + dataMes.yyzZjurl }

          this.fileList.push({
            url: item.img
          })
          item.loading = false
        })
      })
    },
    reset() {
      this.$refs['form'].resetFields()
      this.$emit('close-dialog')
      this.fileList = []
      this.form.zjzpZm = ''
      this.form.zjzpFm = ''
      this.form.jszZjurl = ''
      this.form.yyzZjurl = ''
      this.id = ''
    },
    closeDialog() {
      this.reset()
    }
  }
}
</script>

<style lang="less" scoped>
.cyryDialog {
  /deep/ .el-dialog {
    width: 1084px;
    margin-top: 5vh !important;

    .el-dialog__header {
      width: 100%;
      padding: 0;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      .el-dialog__title {
        display: block;
        padding: 52px 0;
        height: 28px;
        line-height: 0;
      }
    }
    .el-dialog__body {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 !important;

      .leftcyry {
        width: 179.35px;
        margin-left: 85px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        /deep/ .el-upload--picture-card {
          width: 179.35px;
        }
        .card_img_item {
          position: relative;
          .el-image {
            width: 179.35px !important;
            height: 110px !important;
          }
          p {
            margin: 11px 0 40px 0;
          }
        }
      }
      .rightcyry {
        width: 607px;
        margin-right: 144px;
        .el-form {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          & > .el-form-item {
            width: 280px;
            margin-bottom: 20px;
            margin-right: 0;

            .el-form-item__label {
              width: 85px;
              color: #333333;
            }
            .el-form-item__content {
              width: 195px;
              .el-date-editor.el-input,
              .el-date-editor.el-input__inner {
                width: 195px !important;
              }
            }
          }

          & > .yxq {
            width: 100%;
            height: 39px;
            & > .el-form-item__content {
              width: calc(100% - 85px) !important;
            }
            [class*="el-col-11.5"] {
              width: 230px !important;
              & > .el-form-item {
                width: 230px !important;
                margin-right: 0;
                & > .el-form-item__content {
                  width: 230px !important;
                  margin-right: 0;
                  .el-date-editor.el-input,
                  .el-date-editor.el-input__inner {
                    width: 236px !important;
                  }
                }
              }
            }
          }
        }
      }
    }
    .el-dialog__footer {
      width: 100%;
      padding-bottom: 50px;
    }
  }
}
/deep/.elForm {
  width: 280px !important;
}
</style>

